import {getStrategyMarkdown} from './strategyPayload';

const STRATEGY_DOCUMENT_NAME = 'strategy_document';

export const getStrategyDocumentFromSession = (documents) => {
  if (!Array.isArray(documents) || documents.length === 0) {
    return '';
  }

  const strategyDocument = documents.find(
    (item) => item?.name === STRATEGY_DOCUMENT_NAME,
  );

  if (!strategyDocument) {
    return '';
  }

  if (typeof strategyDocument.content === 'string') {
    return strategyDocument.content.trim();
  }

  return getStrategyMarkdown(strategyDocument.content).trim();
};

export const hasStrategyDocumentInSession = (documents) =>
  Boolean(getStrategyDocumentFromSession(documents));
